/**
 * Kennung dieses Browser-Tabs.
 *
 * Der Server adressiert eine laufende Quelle ueber die connectionId der
 * WebSocket -- und die ist nach einem Reload eine andere. Ohne eine zweite,
 * stabilere Kennung koennte eine zurueckkehrende Seite ihre Quelle also nicht
 * wieder uebernehmen, und Freigabe, Hauptbild und kleines Fenster fielen bei
 * jedem F5 auf Anfang.
 *
 * Bewusst `sessionStorage` und nicht `localStorage`: der Wert soll einen
 * Reload ueberleben, aber nicht zwischen zwei Tabs geteilt werden. Sonst
 * riesze eine zweite offene Seite derselben Person die Quelle der ersten an
 * sich -- die Regie mit einem zweiten Zuschauer-Tab ist genau dieser Fall.
 */
const KEY = 'rabbitfuel:device';

let cached: string | null = null;

const randomId = () =>
  typeof crypto?.randomUUID === 'function'
    ? crypto.randomUUID()
    : `dev-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;

export function deviceId(): string {
  if (cached) return cached;
  try {
    const existing = sessionStorage.getItem(KEY);
    if (existing) {
      cached = existing;
      return existing;
    }
    const created = randomId();
    sessionStorage.setItem(KEY, created);
    cached = created;
    return created;
  } catch {
    // Privater Modus: dann eben nur fuer die Lebensdauer dieser Seite. Ein
    // Reload verliert die Quelle -- schlechter als mit Speicher, aber nicht
    // schlechter als vorher.
    cached ??= randomId();
    return cached;
  }
}

/**
 * Kennung dieses Browsers -- anders als `deviceId` in allen Tabs gleich und
 * ueber das Schliessen hinaus. Daran haengen die Botschaften an die Regie:
 * ihre Grenze und eine Sperre gelten fuer die Person am Geraet, nicht fuer
 * einen Tab. Wer seinen Browserspeicher loescht, ist ein neuer Absender --
 * eine harte Grenze ist das nicht, eine Huerde schon.
 */
const CLIENT_KEY = 'rabbitfuel:client';
let cachedClient: string | null = null;

export function clientId(): string {
  if (cachedClient) return cachedClient;
  try {
    const existing = localStorage.getItem(CLIENT_KEY);
    if (existing) return (cachedClient = existing);
    const created = randomId();
    localStorage.setItem(CLIENT_KEY, created);
    return (cachedClient = created);
  } catch {
    cachedClient ??= randomId();
    return cachedClient;
  }
}
